import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {ClientRoutes, Envs, GlobalWindow} from '@/types';

export class QueryStringService {
  private readonly keys = {
    authScenario: 'auth_scenario',
    appName: 'appName',
    appVersion: 'appVersion',
    mobileVersion: 'mbversion',
    auth: 'auth',
    platform: 'platform',
    customSSOToken: 'customSSOToken',
    refId: 'refId',
  };

  constructor(
    private readonly window: GlobalWindow,
    private readonly envs: Envs,
    private readonly clientRoutes: ClientRoutes,
  ) {}

  public getQueryValue(key: string): string | null {
    return new this.window.URL(this.window.location.href).searchParams.get(key);
  }

  public getQueryWithoutRefId(): string {
    const searchParams = new URLSearchParams(this.window.location.search);
    searchParams.delete(this.keys.refId);
    const searchParamsString = searchParams.toString();
    return searchParamsString !== '' ? `?${searchParamsString}` : '';
  }

  public dataToSearchParams(query: Record<string, string | undefined | null | number> = {}): URLSearchParams {
    const searchParams = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value) {
        searchParams.append(key, value.toString());
      }
    });

    return searchParams;
  }

  public getAuthScenario(): string | null {
    return this.getQueryValue(this.keys.authScenario);
  }

  public getMobileVersion(): string | null {
    return this.getQueryValue(this.keys.mobileVersion);
  }

  public getAppVersion(): string | null {
    return this.getQueryValue(this.keys.appVersion);
  }

  public getAppName(): string | null {
    return this.getQueryValue(this.keys.appName);
  }

  public getAuth(): string | null {
    return this.getQueryValue(this.keys.auth);
  }

  public getPlatform(): string | null {
    return this.getQueryValue(this.keys.platform);
  }

  public getCustomSSOToken = (): string | null => {
    return this.getQueryValue(this.keys.customSSOToken);
  };

  public createFriendRefUrl = (refId: string): string => {
    const origin = this.envs.APP_PROJECT_URL;
    const pathname = this.clientRoutes.InvitePage.replace(':refId', refId).replace('*', 'ref');
    return origin + pathname;
  };
}

injected(QueryStringService, DI_TOKENS.globalWindow, DI_TOKENS.envs, DI_TOKENS.clientRoutes);
